import { all, put, takeEvery } from 'redux-saga/effects';
import { SET_ACTION_BUFFER, ERASE_ACTION_BUFFER } from './constants';
import { putActionBufferSuccess, eraseActionBufferSuccess } from './actions';

/**
 *
 * @param actionObject
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{obj: *, type: string}>>, void, *>}
 */
function* onSetBuffer( actionObject ) {
    if ( actionObject ) {
        yield put( putActionBufferSuccess( actionObject ) );
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchSetBuffer() {
    yield takeEvery( SET_ACTION_BUFFER, onSetBuffer );
}

/**
 *
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{type: string}>>, void, *>}
 */
function* eraseBuffer() {
    yield put( eraseActionBufferSuccess() );
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchErraseBuffer() {
    yield takeEvery( ERASE_ACTION_BUFFER, eraseBuffer );
}

/**
 *
 * @returns {Generator<CombinatorEffect<"ALL", Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>>, void, *>}
 */
function* watchActionBuffer() {
    yield all( [
        watchSetBuffer(),
        watchErraseBuffer()
    ] );
}

export default watchActionBuffer;
